/**
 * Quick Add Modal - Implementación robusta para mostrar main-product.liquid
 */

class QuickAddModal {
  constructor() {
    this.modal = null;
    this.modalEl = null; // Agregar esta propiedad que faltaba
    this.modalContent = null;
    this.isOpen = false;
    this.isLoading = false; // Agregar esta propiedad que faltaba
    this.popupEventsInitialized = false; // Flag para evitar inicializar eventos múltiples veces
    this.removedMainProduct = null; // Para almacenar temporalmente el main product removido
    this.mainProductParent = null; // Para recordar dónde estaba el main product
    this.mainProductNextSibling = null; // Para recordar la posición exacta
    this.sliderStates = null; // Para guardar estados de sliders antes de remover
    this.pendingQuickAddColor = '';
    this.pendingQuickAddVariantId = '';
    this.init();
  }

  init() {
    
    this.createModal();
    this.bindEvents();
    this.addNotificationStyles();
    this.addGlobalCartListener();
  }

  addGlobalCartListener() {
    // Escuchar evento personalizado en lugar de monkeypatch de fetch
    // Esto evita la doble interceptación de fetch (minicart.js ya tiene un monkeypatch)
    document.addEventListener('cart:item-added', () => {
      if (this.isOpen) {
        this.close();
      }
    });
  }

  createModal() {
    // Eliminar modal existente si existe
    const existingModal = document.getElementById('quick-add-modal');
    if (existingModal) {
      existingModal.remove();
    }

    // Crear modal HTML
    const modalHTML = `
      <div id="quick-add-modal" class="quick-add-modal" style="display: none; z-index: 9999;" role="dialog" aria-modal="true" aria-labelledby="quick-add-modal-title" aria-hidden="true">
        <div class="quick-add-modal-overlay" data-modal-close></div>
        <div class="quick-add-modal-content" tabindex="-1">
          <div class="quick-add-modal-header">
            <h2 class="quick-add-modal-title" id="quick-add-modal-title">Product preview</h2>
            <button class="quick-add-modal-close" data-modal-close aria-label="Close product preview" type="button">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false">
                <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
          <div class="quick-add-modal-body">
            <div class="quick-add-loading" style="display: none;" aria-live="polite">
              <div class="loading-spinner" aria-hidden="true"></div>
              <p>Loading product...</p>
            </div>
            <div class="quick-add-product-content">
                <!-- Product content will be loaded here -->
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);
    
    this.modal = document.getElementById('quick-add-modal');
    this.modalEl = this.modal; // Asignar la misma referencia
    this.modalContent = this.modal.querySelector('.quick-add-product-content');
    
  }

  bindEvents() {
    if (!this.modal) return;

    // Eventos de cierre con debugging
    const closeElements = this.modal.querySelectorAll('[data-modal-close]');
    closeElements.forEach(element => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      });
    });

    // Cerrar con ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    // Cerrar al hacer click en el overlay (pero no en el contenido)
    const overlay = this.modal.querySelector('.quick-add-modal-overlay');
    if (overlay) {
      overlay.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      });
    }

    // Prevenir cierre al hacer click en el contenido (temporalmente desactivado para debugging)
    const modalContent = this.modal.querySelector('.quick-add-modal-content');
    if (modalContent) {
      modalContent.addEventListener('click', (e) => {
        // Solo prevenir cierre si NO es un elemento interactivo
        const isInteractive = e.target.closest('button, a, input, select, label, .color, [data-color], .variant-input, .swatch, [onclick], [data-option-index]');
        
        if (!isInteractive) {
          e.stopPropagation();
        } else {
        }
      });
    }

    // INTERCEPTOR GLOBAL: Escuchar eventos de add to cart en todo el modal
    this.modal.addEventListener('submit', (e) => {
      if (e.target.closest('form[action*="/cart/add"], .add-to-cart-ec-form')) {
        this.close();
      }
    }, true); // useCapture

    // También escuchar clicks en botones específicos
    this.modal.addEventListener('click', (e) => {
      const addToCartButton = e.target.closest('.product-confirm-select, button[type="submit"], input[type="submit"]');
      if (addToCartButton) {
        this.close();
      }
    }, true); // useCapture

  }

  addNotificationStyles() {
    // Verificar si los estilos ya fueron agregados
    if (document.getElementById('quick-add-notification-styles')) {
      return;
    }

    const styles = document.createElement('style');
    styles.id = 'quick-add-notification-styles';
    styles.textContent = `
      @keyframes slideInRight {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      
      .quick-add-success-notification,
      .quick-add-error-notification {
        transition: all 0.3s ease-out;
      }
      
      .quick-add-success-notification:hover,
      .quick-add-error-notification:hover {
        transform: translateX(-5px);
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15) !important;
      }
      
      /* Asegurar que el minicart aparezca por encima del modal */
      .overlay.overlay--show {
        z-index: 10002 !important;
      }
      
      .mini-cart.mini-cart--show {
        z-index: 10003 !important;
      }
      
      /* Asegurar que el modal tenga z-index menor */
      .quick-add-modal {
        z-index: 9999 !important;
      }
      
      /* Fix para cuando el modal está cerrado, los overlays del minicart no interfieran */
      .overlay:not(.overlay--show) {
        pointer-events: none;
      }
      
      .mini-cart:not(.mini-cart--show) {
        pointer-events: none;
      }
    `;
    
    document.head.appendChild(styles);
  }

  // Métodos para manejar remoción temporal del main product
  temporarilyRemoveMainProduct() {
    // Evitar remover múltiples veces
    if (this.removedMainProduct) {
      console.log('⚠️ Main product ya está removido');
      return true;
    }

    // Buscar el main product en la página
    const mainProductSelectors = [
      'main product-form',
      '.main-product',
      'section[data-section*="main-product"]',
      '#MainProduct',
      'product-form',
      '.product-info',
      '.container-product-info'
    ];
    
    let mainProductElement = null;
    for (const selector of mainProductSelectors) {
      mainProductElement = document.querySelector(selector);
      if (mainProductElement) {
        console.log(`🗑️ Encontrado main product con selector: ${selector}`);
        break;
      }
    }
    
    if (mainProductElement) {
      // Guardar referencias para la restauración
      this.mainProductParent = mainProductElement.parentNode;
      this.mainProductNextSibling = mainProductElement.nextSibling;
      
      // Guardar el estado de los sliders antes de remover
      this.saveSliderStates(mainProductElement);
      
      // Crear un comentario placeholder para marcar la posición
      const placeholder = document.createComment('QUICK_ADD_MODAL_PLACEHOLDER');
      this.mainProductParent.insertBefore(placeholder, mainProductElement);
      
      // Remover el elemento del DOM
      this.removedMainProduct = mainProductElement;
      mainProductElement.remove();
      
      console.log('✅ Main product removido temporalmente del DOM');
      return true;
    } else {
      console.log('⚠️ No se encontró main product para remover');
      return false;
    }
  }
  
  saveSliderStates(element) {
    // Guardar estado de sliders Slick antes de remover
    this.sliderStates = [];
    const sliders = element.querySelectorAll('.slick-initialized');
    
    sliders.forEach((slider, index) => {
      if (typeof $ !== 'undefined' && $.fn.slick) {
        try {
          const currentSlide = $(slider).slick('slickCurrentSlide');
          const slickOptions = $(slider).slick('getSlick').options;
          
          this.sliderStates.push({
            element: slider,
            currentSlide: currentSlide,
            options: slickOptions,
            selector: this.generateSliderSelector(slider)
          });
          
          console.log(`💾 Guardado estado del slider ${index}: slide ${currentSlide}`);
        } catch (error) {
          console.warn('⚠️ Error guardando estado del slider:', error);
        }
      }
    });
  }
  
  generateSliderSelector(element) {
    // Generar un selector único para el elemento
    if (element.id) return `#${element.id}`;
    if (element.className) return `.${element.className.split(' ')[0]}`;
    return element.tagName.toLowerCase();
  }
  
  restoreMainProduct() {
    if (this.removedMainProduct && this.mainProductParent) {
      // Buscar el comentario placeholder
      const placeholder = Array.from(this.mainProductParent.childNodes)
        .find(node => node.nodeType === Node.COMMENT_NODE && node.textContent === 'QUICK_ADD_MODAL_PLACEHOLDER');
      
      if (placeholder) {
        // Restaurar el elemento en su posición original
        this.mainProductParent.insertBefore(this.removedMainProduct, placeholder);
        placeholder.remove();
      } else {
        // Si no se encuentra el placeholder, agregar al final del contenedor padre
        this.mainProductParent.appendChild(this.removedMainProduct);
      }
      
      console.log('✅ Main product restaurado al DOM');
      
      // Esperar un momento para que el DOM se actualice
      setTimeout(() => {
        // Restaurar sliders
        this.restoreSliderStates();
        
        // Reinicializar eventos si es necesario
        this.reinitializeMainProductEvents();
      }, 100);
      
      // Limpiar referencias
      this.removedMainProduct = null;
      this.mainProductParent = null;
      this.mainProductNextSibling = null;
      this.sliderStates = null;
    }
  }
  
  restoreSliderStates() {
    if (!this.sliderStates || this.sliderStates.length === 0) return;
    
    this.sliderStates.forEach((state, index) => {
      try {
        // Buscar el elemento slider en el DOM restaurado
        const slider = document.querySelector(state.selector);
        
        if (slider && typeof $ !== 'undefined' && $.fn.slick) {
          // Si el slider ya está inicializado, destruirlo primero
          if (slider.classList.contains('slick-initialized')) {
            $(slider).slick('unslick');
          }
          
          // Reinicializar con las opciones originales
          $(slider).slick(state.options);
          
          // Ir al slide que estaba activo
          if (state.currentSlide > 0) {
            $(slider).slick('slickGoTo', state.currentSlide);
          }
          
          console.log(`🔄 Restaurado slider ${index} al slide ${state.currentSlide}`);
        }
      } catch (error) {
        console.warn(`⚠️ Error restaurando slider ${index}:`, error);
      }
    });
  }
  
  reinitializeMainProductEvents() {
    // Reinicializar eventos que puedan haberse perdido
    console.log('🔄 Reinicializando eventos del main product');
    
    // Trigger evento personalizado para que otros scripts sepan que el producto fue restaurado
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('mainProductRestored', {
        detail: { element: this.removedMainProduct }
      }));
      
      // También trigger eventos de DOM ready para scripts que lo necesiten
      document.dispatchEvent(new Event('DOMContentLoaded'));
    }, 200);
  }

  async openQuickAdd(productId, productHandle, selectedColor = '', selectedVariantId = '') {
    console.log('🔵🔵🔵 openQuickAdd() llamado - VERSION A11Y');
    try {
      // Prevenir múltiples aperturas simultáneas
      if (this.isLoading) {
        console.log('⚠️ Modal ya está cargando, ignorando nueva apertura');
        return;
      }
      
      this.isLoading = true;
      this.pendingQuickAddColor = selectedColor || '';
      this.pendingQuickAddVariantId = selectedVariantId || '';
      
      // Cerrar modal existente si está abierto
      if (this.modalEl.classList.contains('open')) {
        console.log('🔄 Cerrando modal existente antes de abrir nuevo');
        this.close();
        await new Promise(resolve => setTimeout(resolve, 300)); // Esperar cierre completo
      }
      
      this.open();
      this.showLoading();
      
      // NUEVO: Remover temporalmente el main product del DOM para evitar conflictos
      this.temporarilyRemoveMainProduct();
      
      // Limpiar contenido anterior completamente
      this.clearPreviousContent();
      
      // Cargar contenido del producto
      const productHTML = await this.fetchProductHTML(productHandle);
      
      if (productHTML) {
        this.hideLoading();
        this.showProductContent(productHTML);
        this.applyPendingSelection();
        
        // Esperar a que el contenido sea visible antes de inicializar
        await new Promise(resolve => setTimeout(resolve, 200));
        
        // Inicializar sliders con reinicialización completa
        this.initializeSliders(this.modalEl);
        
        // Inicializar formulario de producto con interceptación mejorada
        this.initProductForm(this.modalEl);
        
        this.hideAddToCartButtons();
      } else {
        this.showError('No se pudo cargar el producto');
      }
      
      this.isLoading = false;
      console.log('✅ Modal abierto exitosamente');
      console.log('✅ Modal abierto exitosamente - VERSION A11Y');
      
    } catch (error) {
      console.error('❌ Error al cargar el producto:', error);
      this.showError('Error al cargar el producto');
      this.isLoading = false;
      this.pendingQuickAddColor = '';
      this.pendingQuickAddVariantId = '';
    }
  }
  
  applyPendingSelection() {
    const container = this.modalContent;
    if (!container) return;

    setTimeout(() => {
      const productId = container.querySelector('product-form')?.dataset.productId;
      if (!productId) return;

      const variantSelect = container.querySelector(`#VariantSelect-${productId}`);
      if (!variantSelect) return;

      if (this.pendingQuickAddVariantId) {
        const option = variantSelect.querySelector(`option[value="${this.pendingQuickAddVariantId}"]`);
        if (option) {
          variantSelect.value = this.pendingQuickAddVariantId;
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
          this.pendingQuickAddColor = '';
          this.pendingQuickAddVariantId = '';
          return;
        }
      }

      if (this.pendingQuickAddColor) {
        this.selectVariantByColor(this.pendingQuickAddColor, container);
      }

      this.pendingQuickAddColor = '';
      this.pendingQuickAddVariantId = '';
    }, 350);
  }
  
  clearPreviousContent() {
    // Destruir sliders existentes antes de limpiar
    const existingSliders = this.modalEl.querySelectorAll('.slick-initialized');
    existingSliders.forEach(slider => {
      try {
        $(slider).slick('unslick');
        console.log('🧹 Slider destruido antes de limpiar contenido');
      } catch (e) {
        // Slider ya destruido o no existe
      }
    });
    
    // Remover event listeners anteriores
    const modalHandledElements = this.modalEl.querySelectorAll('[data-modal-handled="true"]');
    modalHandledElements.forEach(el => {
      el.removeAttribute('data-modal-handled');
    });
    
    console.log('🧹 Contenido anterior limpiado completamente');
  }
  
  // A11y: obtener focusables del modal (excluyendo el modal contenedor mismo)
  getFocusables() {
    if (!this.modal) return [];
    const contentEl = this.modal.querySelector('.quick-add-modal-content');
    const root = contentEl || this.modal;
    return Array.from(root.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(el => {
      // Visible: no display:none ni visibility:hidden
      const style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      // Excluir el propio contenedor con tabindex="-1"
      if (el === root) return false;
      return true;
    });
  }

  open() {
    if (!this.modal) return;

    // A11y: guardar elemento focuseado actual antes de abrir
    this.lastFocusedBeforeOpen = document.activeElement;

    this.isOpen = true;
    this.modal.style.display = 'flex'; // IMPORTANTE: flex como el código original
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open'); // Preservado del código original (puede haber CSS dependiente)

    // IMPORTANTE: el CSS espera `.active` para mostrar (visibility:visible, opacity:1).
    // Forzar reflow para que la transición arranque, luego añadir clases.
    void this.modal.offsetWidth;
    this.modal.classList.add('open');
    this.modal.classList.add('active');

    // Prevenir scroll del body
    document.body.style.overflow = 'hidden';

    // A11y: mover foco al modal — múltiples intentos para sobrevivir al async/transiciones
    const self = this;
    const focusFirstElement = function () {
      if (!self.isOpen) return;
      // Forzar aria-hidden=false ANTES del focus (algo podría haberlo revertido)
      self.modal.setAttribute('aria-hidden', 'false');
      // Asegurar que las clases activas estén
      if (!self.modal.classList.contains('active')) {
        self.modal.classList.add('active');
      }
      const closeBtn = self.modal.querySelector('.quick-add-modal-close');
      const focusables = self.getFocusables();
      const target = closeBtn || focusables[0] || self.modal.querySelector('.quick-add-modal-content');
      if (target) {
        try {
          target.focus({ preventScroll: false });
          console.log('🎯 Focus movido a:', target.tagName, target.className);
        } catch (e) {
          console.log('❌ Error al hacer focus:', e);
        }
      } else {
        console.log('⚠️ No se encontró elemento para hacer focus');
      }
    };
    setTimeout(focusFirstElement, 50);
    setTimeout(focusFirstElement, 200);
    setTimeout(focusFirstElement, 400);
    setTimeout(focusFirstElement, 800);

    // A11y: focus trap — listener DIRECTAMENTE en el modal (más fiable que en document)
    this._boundModalKeydown = function (e) {
      if (!self.isOpen) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        self.close();
        return;
      }
      if (e.key === 'Tab') {
        const focusables = self.getFocusables();
        if (focusables.length === 0) {
          e.preventDefault();
          return;
        }
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        const active = document.activeElement;
        if (!self.modal.contains(active)) {
          e.preventDefault();
          first.focus();
          return;
        }
        if (e.shiftKey && active === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && active === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };
    // Capturar en fase de capture (true) para no perdernos eventos
    this.modal.addEventListener('keydown', this._boundModalKeydown, true);
    // Backup también en document por si el foco se escapa fuera del modal
    document.addEventListener('keydown', this._boundModalKeydown, true);

    console.log('🚪 Modal abierto');
  }

  close() {
    if (!this.modal) return;

    // Prevenir múltiples cierres
    if (!this.isOpen) {
      console.log('⚠️ Modal ya está cerrado');
      return;
    }

    this.isOpen = false;
    this.isLoading = false;

    // Animar cierre
    this.modal.classList.remove('open');
    this.modal.classList.remove('active');
    this.modal.setAttribute('aria-hidden', 'true');

    // A11y: dejar de escuchar Tab/Escape
    if (this._boundModalKeydown) {
      document.removeEventListener('keydown', this._boundModalKeydown, true);
      this._boundModalKeydown = null;
    }

    setTimeout(() => {
      this.modal.style.display = 'none';

      // Restaurar el main product al DOM
      this.restoreMainProduct();

      // Restaurar scroll del body
      document.body.style.overflow = '';

      // A11y: devolver foco al elemento que abrió el modal
      if (this.lastFocusedBeforeOpen && typeof this.lastFocusedBeforeOpen.focus === 'function') {
        try {
          this.lastFocusedBeforeOpen.focus();
        } catch (_) { /* elemento ya no existe en el DOM */ }
      }
      this.lastFocusedBeforeOpen = null;

      console.log('🚪 Modal cerrado y main product restaurado');
    }, 300);
  }
  
  // showLoading, hideLoading y showError duplicados eliminados — usar los originales más abajo (líneas ~2820-2860)

  async fetchProductHTML(productHandle) {
    
    try {
      // Método 1: Cargar la página COMPLETA del producto para incluir todos los bloques
      
      const fullPageResponse = await fetch(`/products/${productHandle}`);
      
      if (fullPageResponse.ok) {
        const fullPageHTML = await fullPageResponse.text();
        
        // Extraer la sección del producto con TODOS sus bloques y popups
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = fullPageHTML;
        
        // Buscar el contenido principal del producto
        const productSection = tempDiv.querySelector('product-form, .product-info, [data-section*="main-product"], section.main-product');
        
        if (productSection) {
          let fullHTML = productSection.outerHTML;
          
          // Buscar específicamente el content-buy-bar
          const contentBuyBar = tempDiv.querySelector('.content-buy-bar');
          if (contentBuyBar) {
            fullHTML += contentBuyBar.outerHTML;
          }
          
          // También extraer los popups de shipping, assembly, etc. que están fuera de product-info
          const shippingPopup = tempDiv.querySelector('.container-popup-product.shipping');
          const assemblyPopup = tempDiv.querySelector('.container-popup-product.assembly');
          const returnPolicyPopup = tempDiv.querySelector('.container-popup-product.return-policy');
          
          // Agregar los popups al HTML si existen
          if (shippingPopup) {
            fullHTML += shippingPopup.outerHTML;
          }
          if (assemblyPopup) {
            fullHTML += assemblyPopup.outerHTML;
          }
          if (returnPolicyPopup) {
            fullHTML += returnPolicyPopup.outerHTML;
          }
          
          return fullHTML;
        }
      }
      
      // Método 2: Usar la API de Sections de Shopify (sin los popups) como fallback
      
      const sectionId = 'main-product';
      const sectionsResponse = await fetch(`/products/${productHandle}?sections=${sectionId}`);
      
      if (sectionsResponse.ok) {
        const sectionsData = await sectionsResponse.json();
        
        if (sectionsData && sectionsData[sectionId]) {
          return sectionsData[sectionId];
        }
      }
      
      // Método 3: Intentar con diferentes nombres de sección
      const alternativeSections = ['product-form', 'MainProduct'];
      
      for (const altSection of alternativeSections) {
        
        try {
          const altResponse = await fetch(`/products/${productHandle}?sections=${altSection}`);
          if (altResponse.ok) {
            const altData = await altResponse.json();
            
            if (altData && altData[altSection]) {
              return altData[altSection];
            }
          }
        } catch (altError) {
        }
      }
      
      // Método 4: Usar snippet como último recurso (sin template)
      const snippetResponse = await fetch(`/products/${productHandle}?section_id=main-product`);
      
      if (snippetResponse.ok) {
        const snippetHTML = await snippetResponse.text();
        if (snippetHTML && snippetHTML.trim()) {
          return snippetHTML;
        }
      }

      throw new Error('No product content found via sections API');
      
    } catch (error) {
      console.error('❌ Error fetching product HTML:', error);
      return null;
    }
  }
  
  initializeSliders(container) {
    console.log('🎠 Inicializando sliders en modal...');
    
    // Esperar un frame para asegurar que el DOM esté listo
    requestAnimationFrame(() => {
      // Buscar todos los posibles contenedores de sliders
      const sliderSelectors = [
        '.product-gallery-slider',
        '.thumbs-slider',
        '.main-slider',
        '.secondary-slider',
        '.slick-slider',
        '[data-slick]'
      ];
      
      sliderSelectors.forEach(selector => {
        const sliders = container.querySelectorAll(selector);
        
        sliders.forEach((slider, index) => {
          try {
            // Si ya está inicializado, destruirlo primero
            if (slider.classList.contains('slick-initialized')) {
              $(slider).slick('unslick');
              console.log(`🔄 Slider ${selector} reinicializado`);
            }
            
            // Configuraciones específicas por tipo de slider
            let config = this.getSliderConfig(selector, slider);
            
            // Inicializar con jQuery y Slick
            $(slider).slick(config);
            
            console.log(`✅ Slider ${selector} #${index + 1} inicializado correctamente`);
            
          } catch (error) {
            console.warn(`⚠️ Error inicializando slider ${selector}:`, error);
          }
        });
      });
      
      // Trigger de resize para asegurar dimensiones correctas
      setTimeout(() => {
        $(window).trigger('resize');
        console.log('🔄 Resize trigger enviado para sliders');
      }, 100);
    });
  }
  
  getSliderConfig(selector, element) {
    // Configuraciones base por tipo de slider
    const configs = {
      '.product-gallery-slider': {
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: true,
        asNavFor: '.thumbs-slider'
      },
      '.thumbs-slider': {
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.product-gallery-slider',
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      },
      'default': {
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: true
      }
    };
    
    // Intentar obtener configuración desde data attributes
    const dataConfig = element.getAttribute('data-slick');
    if (dataConfig) {
      try {
        return JSON.parse(dataConfig);
      } catch (e) {
        console.warn('⚠️ Error parseando data-slick config:', e);
      }
    }
    
    // Usar configuración específica o default
    return configs[selector] || configs['default'];
  }

  hideAddToCartButtons() {
    // console.log('Hiding add to cart buttons in modal');
    if (!this.modalContent) return;
    // console.log('Modal content found, hiding buttons');
    const addToCartButtons = this.modalContent.querySelectorAll('.product-confirm-select, button[type="submit"], input[type="submit"]');
    addToCartButtons.forEach(button => {
      button.style.display = 'none';
      button.style.visibility = 'hidden';
      button.setAttribute('aria-hidden', 'true');
    });
  }

  showAddToCartButtons() {
    // console.log('Showing add to cart buttons in modal');
    if (!this.modalContent) return;
    // console.log('Modal content found, showing buttons');
    const addToCartButtons = this.modalContent.querySelectorAll('.product-confirm-select, button[type="submit"], input[type="submit"]');
    addToCartButtons.forEach(button => {
      button.style.display = '';
      button.style.visibility = '';
      button.removeAttribute('aria-hidden');
    });
  }

  async fetchProductHTML(productHandle) {
    
    try {
      // Método 1: Cargar la página COMPLETA del producto para incluir todos los bloques
      
      const fullPageResponse = await fetch(`/products/${productHandle}`);
      
      if (fullPageResponse.ok) {
        const fullPageHTML = await fullPageResponse.text();
        
        // Extraer la sección del producto con TODOS sus bloques y popups
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = fullPageHTML;
        
        // Buscar el contenido principal del producto
        const productSection = tempDiv.querySelector('product-form, .product-info, [data-section*="main-product"], section.main-product');
        
        if (productSection) {
          let fullHTML = productSection.outerHTML;
          
          // Buscar específicamente el content-buy-bar
          const contentBuyBar = tempDiv.querySelector('.content-buy-bar');
          if (contentBuyBar) {
            fullHTML += contentBuyBar.outerHTML;
          } else {
          }
          
          // También extraer los popups de shipping, assembly, etc. que están fuera de product-info
          const shippingPopup = tempDiv.querySelector('.container-popup-product.shipping');
          const assemblyPopup = tempDiv.querySelector('.container-popup-product.assembly');
          const returnPolicyPopup = tempDiv.querySelector('.container-popup-product.return-policy');
          
          // Agregar los popups al HTML si existen
          if (shippingPopup) {
            fullHTML += shippingPopup.outerHTML;
          }
          if (assemblyPopup) {
            fullHTML += assemblyPopup.outerHTML;
          }
          if (returnPolicyPopup) {
            fullHTML += returnPolicyPopup.outerHTML;
          }
          
          return fullHTML;
        }
      }
      
      // Método 2: Usar la API de Sections de Shopify (sin los popups) como fallback
      
      const sectionId = 'main-product';
      const sectionsResponse = await fetch(`/products/${productHandle}?sections=${sectionId}`);
      
      if (sectionsResponse.ok) {
        const sectionsData = await sectionsResponse.json();
        
        if (sectionsData && sectionsData[sectionId]) {
          return sectionsData[sectionId];
        }
      }
      
      // Método 2: Intentar con diferentes nombres de sección
      const alternativeSections = ['product-form', 'MainProduct'];
      
      for (const altSection of alternativeSections) {
        
        try {
          const altResponse = await fetch(`/products/${productHandle}?sections=${altSection}`);
          if (altResponse.ok) {
            const altData = await altResponse.json();
            
            if (altData && altData[altSection]) {
              return altData[altSection];
            }
          }
        } catch (altError) {
        }
      }
      
      // Método 3: Usar snippet como último recurso (sin template)
      const snippetResponse = await fetch(`/products/${productHandle}?section_id=main-product`);
      
      if (snippetResponse.ok) {
        const snippetHTML = await snippetResponse.text();
        if (snippetHTML && snippetHTML.trim()) {
          return snippetHTML;
        }
      }

      throw new Error('No product content found via sections API');
      
    } catch (error) {
      return null;
    }
  }

  showProductContent(htmlContent) {
    if (!this.modalContent) return;
    
    
    // Crear un div temporal para analizar el contenido
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    
    // Debug: verificar qué elementos tenemos
    
    // Separar el contenido del producto de los popups
    const productInfo = tempDiv.querySelector('product-form');
    let contentBuyBar = tempDiv.querySelector('.content-buy-bar');
    const popups = tempDiv.querySelectorAll('.container-popup-product');
    
    // Si no encontramos content-buy-bar directamente, buscar dentro de container-product-info-details
    if (!contentBuyBar) {
      const containerDetails = tempDiv.querySelector('.container-product-info-details');
      if (containerDetails) {
        contentBuyBar = containerDetails.querySelector('.content-buy-bar');
      }
    }
    
    // También buscar en todo el documento como último recurso
    if (!contentBuyBar) {
      const allBuyBars = tempDiv.querySelectorAll('.content-buy-bar');
      if (allBuyBars.length > 0) {
        contentBuyBar = allBuyBars[0]; // Tomar el primero
      }
    }
    
    if (productInfo) {
      let modalContentHTML = productInfo.outerHTML;
      
      // Agregar el content-buy-bar si existe (footer del modal)
      if (contentBuyBar) {
        modalContentHTML += contentBuyBar.outerHTML;
      } else {
      }
      
      // Insertar el contenido del producto + buy bar en el modal
      this.modalContent.innerHTML = modalContentHTML;
      
      // Verificar que se insertó correctamente
      const insertedBuyBar = this.modalContent.querySelector('.content-buy-bar');
      
      // Agregar los popups al body del documento (fuera del modal)
      popups.forEach(popup => {
        // Verificar si el popup ya existe en el documento
        const existingPopup = document.querySelector(`.container-popup-product.${popup.classList[1]}`);
        if (existingPopup) {
          // Actualizar el popup existente
          existingPopup.outerHTML = popup.outerHTML;
        } else {
          // Agregar nuevo popup al documento
          document.body.appendChild(popup);
        }
        
        // IMPORTANTE: Asegurar que el popup tenga z-index más alto que el modal
        const finalPopup = document.querySelector(`.container-popup-product.${popup.classList[1]}`);
        if (finalPopup) {
          finalPopup.style.zIndex = '10000'; // Más alto que el modal (9999)
        }
      });
    } else {
      // Fallback: insertar todo el contenido
      this.modalContent.innerHTML = htmlContent;
    }
    
    // Inicializar todo después de un breve delay
    setTimeout(() => {
      this.initializeProductFeatures();
    }, 100);
  }

  initializeProductFeatures() {
    
    const container = this.modalContent;
    
    // Ya no necesitamos cargar scripts - están cargados desde theme.liquid
    
    // Inicializar en secuencia directamente
    setTimeout(() => {
      // Paso 1: Inicializar custom elements de Shopify
      this.initShopifyElements(container);
      
      // Paso 2: Ejecutar scripts del producto
      setTimeout(() => {
        this.executeProductScripts(container);
        
        // Paso 3: Inicializar componentes específicos
        setTimeout(() => {
          this.initSpecificComponents(container);
          
          // Paso 4: Inicializar sliders con estado inicial adecuado
          setTimeout(() => {
            const productId = container.querySelector('product-form')?.dataset.productId;
            
            // Preparar estado inicial ANTES de inicializar slider
            let initialVariantId = null;
            if (productId) {
              const variantSelect = container.querySelector(`#VariantSelect-${productId}`);
              initialVariantId = variantSelect?.value;
            }
            
            // Inicializar slider con estado inicial coordinado
            this.initSliders(container, initialVariantId);
            
            // NO aplicar estado inicial aquí - ya se hace en initSliders
            
            // Paso 5: Trigger eventos finales (sin afectar imágenes)
            setTimeout(() => {
              this.triggerEvents(container);
            }, 400);
          }, 300);
        }, 200);
      }, 200);
    }, 100);
  }

  initSpecificComponents(container) {
    
    // Ocultar elementos no deseados en el modal (rating y notify)
    this.hideUnwantedElements(container);
    
    // Inicializar el sistema de variantes exactamente como en la interna
    this.initVariantSystem(container);
    
    // Inicializar pickup availability
    this.initPickupAvailability(container);
    
    // Inicializar product form
    this.initProductForm(container);
    
    // Inicializar botones y elementos interactivos adicionales
    this.initInteractiveElements(container);
  }

  hideUnwantedElements(container) {
    
    // Asegurar que solo afectamos elementos dentro del modal
    if (!container || !container.closest('#quick-add-modal')) {
      return;
    }
    
    // 1. Ocultar elementos de rating (product-rating) - MÁS ESPECÍFICO
    const ratingElements = container.querySelectorAll(
      '.product-rating, product-rating, [data-rating], .rating-stars, .reviews-count'
    );
    
    ratingElements.forEach((element, index) => {
      // Agregar clase específica del modal y ocultar inmediatamente
      element.classList.add('hidden-by-modal');
      element.style.display = 'none !important';
      element.style.visibility = 'hidden';
      element.setAttribute('aria-hidden', 'true');
    });
    
    // 2. Ocultar elementos específicos de estrellas o valoraciones - MÁS ESPECÍFICO
    const starElements = container.querySelectorAll(
      '.rating-star, .star-rating, .product-reviews, .review-stars'
    );
    
    starElements.forEach((element, index) => {
      // Solo ocultar si no son elementos de navegación o funcionales
      if (!element.closest('.slider-controls, .navigation, .menu, .breadcrumb')) {
        element.classList.add('hidden-by-modal');
        element.style.display = 'none !important';
        element.style.visibility = 'hidden';
        element.setAttribute('aria-hidden', 'true');
      }
    });
    
    // 3. Ocultar elementos de notify - MÁS ESPECÍFICOS
    const notifyElements = container.querySelectorAll(
      '.notify-me, .notify-link, [data-notify-me], ' +
      '[id*="restock"], .restock-notification, .back-in-stock, ' +
      '.size-notification, [data-popup="size-notification"], ' +
      '.notification-form, .notify-wrapper'
    );
    
    notifyElements.forEach((element, index) => {
      element.classList.add('hidden-by-modal');
      element.style.display = 'none !important';
      element.style.visibility = 'hidden';
      element.setAttribute('aria-hidden', 'true');
    });
    
    // 4. Buscar elementos por texto específico - MÁS RESTRICTIVO
    const potentialNotifyElements = container.querySelectorAll('p.notify-link, button.notify-link, .notify-text');
    potentialNotifyElements.forEach(element => {
      const text = element.textContent.toLowerCase().trim();
      if (text.includes('notify me when') || 
          text.includes('size is available') || 
          text.includes('back in stock') ||
          text.includes('restock notification')) {
        
        element.classList.add('hidden-by-modal');
        element.style.display = 'none !important';
        element.style.visibility = 'hidden';
        element.setAttribute('aria-hidden', 'true');
      }
    });
    
    const totalHidden = ratingElements.length + starElements.length + notifyElements.length;
  }

  initVariantSystem(container) {
    
    // Buscar el VariantSelect y los datos del producto
    const productId = container.querySelector('product-form')?.dataset.productId;
    
    if (!productId) {
      return;
    }
    
    const variantSelect = container.querySelector(`#VariantSelect-${productId}`);
    const productData = this.getProductData(container);
    const buttons = container.querySelectorAll('[data-option-index]');
    const formInputs = container.querySelectorAll('.add-to-cart-ec-form input[name="id"]');
    const priceCurrents = container.querySelectorAll('.price-current');
    const priceOlds = container.querySelectorAll('.price-old');
    
    if (!variantSelect || !productData) {
      return;
    }
    
    // Listener para el select (igual que en la interna)
    variantSelect.addEventListener('change', (e) => {
      const variantId = e.target.value;
      
      if (window.renderPickupSection && variantId) {
        window.renderPickupSection(variantId);
      }
      
      // Trigger nuestra función de actualización de galería
      this.updateImageGallery(variantId, container);
    });
    
    // Listeners para los botones de opciones (igual que en la interna)
    buttons.forEach(el => {
      el.addEventListener('click', () => {
        
        // Todas las variantes son clicables
        const group = el.parentNode;
        group.querySelectorAll('button, input').forEach(i => i.classList.remove('selected'));
        el.classList.add('selected');
        if (el.tagName === 'INPUT') el.checked = true;

         // Actualizar texto del color si es un botón de color
        if (el.classList.contains('color-option')) {
          const colorName = el.dataset.optionValue;
          const colorSection = el.closest('.product-color-section');
          if (colorSection && colorName) {
            const colorDescSpan = colorSection.querySelector('.color-text-description');
            if (colorDescSpan) {
              colorDescSpan.textContent = colorName;
            }
          }
        }
        
        const selected = productData.options.map((_, i) => {
          const btn = container.querySelector(`[data-option-index="${i}"].selected`);
          return btn ? btn.dataset.optionValue : null;
        });

        const variant = productData.variants.find(v =>
          v.options.every((o, i) => o === selected[i])
        );
        
        if (!variant) {
          return;
        }

        variantSelect.value = variant.id;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

        formInputs.forEach(input => input.value = variant.id);

        const opt = variantSelect.querySelector(`option[value="${variant.id}"]`);
        priceCurrents.forEach(pc => {
          if (opt.dataset.price) pc.textContent = opt.dataset.price;
        });
        priceOlds.forEach(po => {
          // Validación numérica para compare_at_price como en main-product.liquid
          const compareAtPrice = variant.compare_at_price;
          const regularPrice = variant.price;
          
          // Solo mostrar compare_at_price si existe y es mayor que el precio regular
          if (compareAtPrice && compareAtPrice !== 0 && compareAtPrice > regularPrice) {
            // Usar el precio ya formateado desde el data-attribute del option
            if (opt.dataset.compareAtPrice) {
              po.textContent = opt.dataset.compareAtPrice;
              po.style.display = '';
            } else {
              po.style.display = 'none';
            }
          } else {
            po.style.display = 'none';
          }
        });

        this.updateVariantAvailability(container, productData);

        // Notificar cambios (igual que en la interna)
        container.dispatchEvent(new CustomEvent('variant:change', { 
          detail: { variant },
          bubbles: true 
        }));
        
        // Actualizar disponibilidad del botón add to cart (igual que en la interna)
        this.updateAvailability(variant, container);
      });
    });
    
    // Función para actualizar disponibilidad (igual que en la interna)
    this.updateVariantAvailability(container, productData);
    
    // Inicializar disponibilidad del botón add to cart
    const currentVariant = productData.variants.find(v => v.id == variantSelect.value);
    if (currentVariant) {
      this.updateAvailability(currentVariant, container);
    }
    
    // Inicializar selección actual
    if (variantSelect.value) {
      const initialVariant = productData.variants.find(v => v.id == variantSelect.value);
      if (initialVariant) {
        initialVariant.options.forEach((optionValue, index) => {
          const button = container.querySelector(`[data-option-index="${index}"][data-option-value="${optionValue}"]`);
          if (button) {
            button.classList.add('selected');
            if (button.tagName === 'INPUT') {
              button.checked = true;
            }
          }
        });
      } else {
        variantSelect.value = '';
      }
    }
    
  }

  updateVariantAvailability(container, productData) {
    const selected = productData.options.map((_, i) => {
      const btn = container.querySelector(`[data-option-index="${i}"].selected`);
      return btn ? btn.dataset.optionValue : null;
    });

    productData.options.forEach((option, optionIndex) => {
      const optionButtons = container.querySelectorAll(`[data-option-index="${optionIndex}"]`);
      
      optionButtons.forEach(button => {
        const testSelection = [...selected];
        testSelection[optionIndex] = button.dataset.optionValue;

        const hasAvailableVariant = productData.variants.some(variant => {
          const canPurchase = variant.available || variant.inventory_policy === "continue";
          if (!canPurchase) return false;
          return testSelection.every((val, idx) =>
            val === null || variant.options[idx] === val
          );
        });

        button.classList.toggle('unavailable', !hasAvailableVariant);
        button.classList.toggle('disabled', !hasAvailableVariant);
        button.dataset.unavailable = hasAvailableVariant ? "false" : "true";

        if (button.tagName === 'INPUT') {
          if (button.nextElementSibling?.tagName === 'LABEL') {
            button.nextElementSibling.classList.toggle('disabled', !hasAvailableVariant);
          }
        }
      });
    });
  }

  updateImageGallery(variantId, container) {
    
    // Buscar los datos de imágenes de variantes
    const productId = container.querySelector('product-form')?.dataset.productId;
    if (!productId) {
      return;
    }
    
    const variantImagesScript = container.querySelector(`#VariantImagesData-${productId}`);
    if (!variantImagesScript) {
      return;
    }
    
    try {
      const variantImagesData = JSON.parse(variantImagesScript.textContent);
      
      // La estructura puede ser diferentes según el tema
      let imageUrls = null;
      
      // Opción 1: Acceso directo por variant ID
      if (variantImagesData[variantId]) {
        imageUrls = variantImagesData[variantId];
      }
      // Opción 2: Estructura con variantImageGroups
      else if (variantImagesData.variantImageGroups && variantImagesData.variantImageGroups[variantId]) {
        imageUrls = variantImagesData.variantImageGroups[variantId];
      }
      // Opción 3: Buscar en arrays
      else if (Array.isArray(variantImagesData)) {
        const variantImageData = variantImagesData.find(item => 
          item.variantId === variantId || item.id === variantId
        );
        if (variantImageData) {
          imageUrls = variantImageData.images || variantImageData.urls;
        }
      }
      
      if (imageUrls && imageUrls.length > 0) {
        // Implementar la misma lógica que en la interna
        this.performGalleryUpdate(variantId, container, imageUrls);
      } else {
        // Mostrar imágenes por defecto sin cambiar el slider
        this.showCurrentImages(container);
      }
    } catch (error) {
      this.showCurrentImages(container);
    }
  }

  performGalleryUpdate(variantId, container, imageUrls) {
    const contentSlider = container.querySelector('.content-slider');
    const skeleton = container.querySelector('.content-slider-skeleton');
    
    if (!contentSlider) {
      return;
    }
    
    
    // Verificar que tenemos imágenes válidas
    if (!imageUrls || imageUrls.length === 0) {
      this.showCurrentImages(container);
      return;
    }
    
    // Procesar las URLs de imagen - pueden ser strings u objetos
    const processedImageUrls = imageUrls.map(imageItem => {
      if (typeof imageItem === 'string') {
        return imageItem;
      } else if (typeof imageItem === 'object' && imageItem !== null) {
        // El objeto puede tener diferentes propiedades según el tema
        return imageItem.src || imageItem.url || imageItem.image_url || imageItem.large || imageItem.original || imageItem.href || imageItem;
      }
      return imageItem;
    }).filter(url => url && typeof url === 'string');
    
    
    if (!processedImageUrls || processedImageUrls.length === 0) {
      this.showCurrentImages(container);
      return;
    }
    
    // Optimización: Si el slider ya tiene estas imágenes, no hacer nada
    const currentImages = Array.from(contentSlider.querySelectorAll('img')).map(img => img.src);
    const imagesMatch = processedImageUrls.length === currentImages.length && 
                       processedImageUrls.every((url, index) => currentImages[index] && currentImages[index].includes(url));
    
    if (imagesMatch) {
      return;
    }
    
    // Mostrar skeleton solo si es necesario cambiar imágenes
    if (skeleton) {
      skeleton.style.display = 'block';
      skeleton.classList.add('show');
    }
    
    // Mantener el slider visible durante la transición pero mostrar skeleton
    contentSlider.style.visibility = 'hidden';
    contentSlider.classList.add('hide');
    
    // Destruir slider actual si existe
    if (contentSlider.classList.contains('slick-initialized')) {
      try {
        $(contentSlider).slick('unslick');
      } catch (error) {
      }
    }
    
    
    // Generar el HTML de los slides SIN botones de zoom
    const slidesHtml = processedImageUrls.map((imageUrl, index) => `
      <div class="slide">
        <div class="slide-image" style="cursor: pointer;" data-redirect-to-product>
          <img src="${imageUrl}" alt="Product image ${index + 1}" loading="lazy">
        </div>
      </div>
    `).join('');
    
    // Actualizar el contenido del slider
    contentSlider.innerHTML = slidesHtml;
    
    // Reinicializar el slider con un delay mínimo
    setTimeout(() => {
      this.reinitializeSlider(container);
    }, 50);
  }
  
  showCurrentImages(container) {
    
    const contentSlider = container.querySelector('.content-slider');
    const skeleton = container.querySelector('.content-slider-skeleton');
    
    if (!contentSlider) return;
    
    // Simplemente hacer visible el slider actual sin cambios
    setTimeout(() => {
      if (skeleton) {
        skeleton.style.display = 'none';
        skeleton.classList.remove('show');
      }
      
      contentSlider.style.visibility = 'visible';
      contentSlider.classList.remove('hide');
      
    }, 100);
  }
  
  showDefaultImages(container) {
    
    const contentSlider = container.querySelector('.content-slider');
    const skeleton = container.querySelector('.content-slider-skeleton');
    
    if (!contentSlider) return;
    
    // Para imágenes por defecto, simplemente reinicializar con las imágenes existentes
    setTimeout(() => {
      this.reinitializeSlider(container);
    }, 100);
  }
  
  reinitializeSlider(container) {
    const contentSlider = container.querySelector('.content-slider');
    const skeleton = container.querySelector('.content-slider-skeleton');
    
    if (!contentSlider) return;
    
    try {
      // Inicializar slider con callback (mantener skeleton hasta estar listo)
      $(contentSlider).on('init', function() {
        // Solo ocultar skeleton cuando el slider esté completamente listo
        setTimeout(() => {
          if (skeleton) {
            skeleton.style.display = 'none';
            skeleton.classList.remove('show');
          }
          
          contentSlider.style.visibility = 'visible';
          contentSlider.classList.remove('hide');
          
        }, 100);
      }).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        infinite: false,
        fade: true
      });
      
      // Eventos para redirigir a la página interna del producto
      $(contentSlider).off('click', '.slide img, .slide-image').on('click', '.slide img, .slide-image', (e) => {
        // Mantener comportamiento original de las imágenes
      });
      
    } catch (error) {
      
      // Fallback: simplemente mostrar el slider
      if (skeleton) {
        skeleton.style.display = 'none';
        skeleton.classList.remove('show');
      }
      contentSlider.style.visibility = 'visible';
      contentSlider.classList.remove('hide');
    }
  }

  applyInitialVariantState(container, productId) {
    
    const variantSelect = container.querySelector(`#VariantSelect-${productId}`);
    if (!variantSelect || !variantSelect.value) {
      return;
    }
    
    const selectedVariantId = variantSelect.value;
    
    // Aplicar las imágenes de la variante inicial
    this.updateImageGallery(selectedVariantId, container);
  }

  initPickupAvailability(container) {
    
    // Buscar elementos de pickup availability
    const pickupElements = container.querySelectorAll('[data-pickup-availability]');
    
    pickupElements.forEach(element => {
      // Si existe el constructor global PickupAvailability
      if (window.PickupAvailability) {
        try {
          new window.PickupAvailability(element);
        } catch (error) {
        }
      }
    });
  }

  initProductForm(container) {
    
    // ENFOQUE MEJORADO: Interceptar eventos de manera más controlada
    const allSubmitButtons = container.querySelectorAll('button[type="submit"], input[type="submit"], .product-confirm-select');
    
    allSubmitButtons.forEach((button, index) => {
      // Marcar el botón como manejado por el modal
      button.setAttribute('data-modal-handled', 'true');
      
      // Interceptar con useCapture para capturar antes que otros eventos
      button.addEventListener('click', (e) => {
        console.log(`🛑 Interceptando botón ${index + 1} en modal`);
        
        // Prevenir la acción por defecto ANTES de cerrar
        e.preventDefault();
        e.stopImmediatePropagation();
        
        // Obtener la información del formulario antes de cerrar
        const form = button.closest('form');
        const formData = form ? new FormData(form) : null;
        
        // Cerrar el modal primero
        this.close();
        
        // Procesar el add to cart en el contexto principal después de un delay
        setTimeout(() => {
          if (formData && form) {
            this.processAddToCartFromModal(form, formData);
          }
        }, 100);
        
      }, true); // useCapture = true
    });
    
    // También interceptar formularios como backup
    const productForms = container.querySelectorAll('form[action*="/cart/add"], .add-to-cart-ec-form');
    
    productForms.forEach(form => {
      form.addEventListener('submit', (e) => {
        console.log('🛑 Interceptando submit de formulario en modal');
        e.preventDefault();
        e.stopImmediatePropagation();
        
        const formData = new FormData(form);
        this.close();
        
        setTimeout(() => {
          this.processAddToCartFromModal(form, formData);
        }, 100);
        
      }, true); // useCapture = true
    });
    
    // Buscar el custom element product-form
    const productFormElement = container.querySelector('product-form');
    if (productFormElement && productFormElement.connectedCallback) {
      try {
        productFormElement.connectedCallback();
        // console.log('✅ Product form element initialized');
      } catch (error) {
        console.warn('⚠️ Error initializing product form element:', error);
      }
    }
    
    console.log(`✅ Intercepted ${allSubmitButtons.length} submit buttons and ${productForms.length} forms in modal`);
  }
  
  processAddToCartFromModal(form, formData) {
    // Procesar el add to cart usando la funcionalidad existente del tema
    console.log('🛒 Procesando add to cart desde modal');
    
    try {
      // Método 1: Intentar usar el sistema de minicart existente
      if (window.minicart && typeof window.minicart.addToCart === 'function') {
        const variantId = formData.get('id');
        const quantity = formData.get('quantity') || 1;
        
        window.minicart.addToCart(variantId, quantity);
        return;
      }
      
      // Método 2: Crear una petición fetch manual
      const formDataObj = {};
      for (let [key, value] of formData.entries()) {
        formDataObj[key] = value;
      }
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{
            id: formDataObj.id,
            quantity: parseInt(formDataObj.quantity) || 1
          }]
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('✅ Producto agregado al carrito desde modal');
        
        // Trigger eventos para actualizar UI
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        document.dispatchEvent(new CustomEvent('cart:add', { detail: data }));
        
        // Publicar evento PUB_SUB para sincronizar con cart.js y minicart.js
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { 
            source: 'quick-add', 
            cartData: data 
          });
        }
      })
      .catch(error => {
        console.error('❌ Error agregando al carrito desde modal:', error);
      });
      
    } catch (error) {
      console.error('❌ Error procesando add to cart:', error);
    }
  }

  initInteractiveElements(container) {
    // console.log('🔧 Initializing additional interactive elements');
    
    // NO inicializar botones de notificación ya que están ocultos
    // Los elementos de notify están completamente ocultos en el modal
    
    // Inicializar accordions/collapsibles
    const accordions = container.querySelectorAll('.accordion, [data-toggle]');
    accordions.forEach(accordion => {
      accordion.addEventListener('click', (e) => {
        // console.log('📋 Accordion toggled');
        // Manejar toggle del accordion
      });
    });
    
    // Inicializar manejo de popups (igual que en main-product.js)
    this.initPopupHandlers(container);
  }

  initColorSelectors(container) {
    // console.log('🔧 Initializing color selectors');
    
    // Buscar elementos de color
    const colorElements = container.querySelectorAll('.color[data-color]');
    
    colorElements.forEach(colorElement => {
      colorElement.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const colorName = colorElement.dataset.color;
        const colorImage = colorElement.dataset.colorImage;
        const colorUrl = colorElement.dataset.url;
        
         console.log(`🎨 Color selected: ${colorName}`, { colorImage, colorUrl });
        
        // Remover clase selected de otros colores
        const allColors = container.querySelectorAll('.color');
        allColors.forEach(c => c.classList.remove('selected'));
        
        // Agregar clase selected al color clickeado
        colorElement.classList.add('selected');
        
        // Cambiar imagen del producto si existe
        if (colorImage) {
          this.updateMainProductImage(colorImage, container);
        }
        
        // Buscar la variante correspondiente y seleccionarla
        this.selectVariantByColor(colorName, container);
      });
    });
    
    // console.log(`✅ ${colorElements.length} color selectors initialized`);
  }

  updateMainProductImage(newImageSrc, container) {
    // console.log('🖼️ Updating main product image:', newImageSrc);
    
    // Buscar la imagen principal del producto
    const mainImage = container.querySelector('.content-img img, .product-image img, .changeImage');
    
    if (mainImage) {
      mainImage.src = newImageSrc;
      // console.log('✅ Main image updated');
    }
    
    // También actualizar slider si existe
    const sliderImages = container.querySelectorAll('.content-slider img');
    if (sliderImages.length > 0) {
      // Actualizar la primera imagen del slider
      sliderImages[0].src = newImageSrc;
      // console.log('✅ Slider image updated');
    }
  }

  selectVariantByColor(colorName, container) {
    // console.log(`🔄 Selecting variant by color: ${colorName}`);
    
    // Buscar radio buttons o select options que contengan el color
    const variantInputs = container.querySelectorAll('input[type="radio"][name="id"], select[name="id"] option');
    
    variantInputs.forEach(input => {
      if (input.tagName === 'INPUT') {
        // Para radio buttons, verificar el label o data attributes
        const label = container.querySelector(`label[for="${input.id}"]`);
        const labelText = label ? label.textContent.trim() : '';
        
        if (labelText.toLowerCase().includes(colorName.toLowerCase()) || 
            input.value.includes(colorName) ||
            input.dataset.color === colorName) {
          
          // console.log(`✅ Found matching variant input: ${input.value}`);
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      } else if (input.tagName === 'OPTION') {
        // Para select options
        if (input.textContent.toLowerCase().includes(colorName.toLowerCase())) {
          // console.log(`✅ Found matching variant option: ${input.value}`);
          input.selected = true;
          input.parentElement.value = input.value;
          input.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    });
  }

  handleVariantChange(variantId, container) {
    // console.log(`🔄 Handling variant change to: ${variantId}`);
    
    // Buscar los datos del producto en los scripts JSON
    const productData = this.getProductData(container);
    
    if (productData && productData.variants) {
      const selectedVariant = productData.variants.find(v => v.id.toString() === variantId.toString());
      
      if (selectedVariant) {
        // console.log('✅ Found variant data:', selectedVariant);
        
        // Actualizar precio
        this.updatePrice(selectedVariant, container);
        
        // Actualizar imagen
        this.updateProductImage(selectedVariant, container);
        
        // Actualizar disponibilidad
        this.updateAvailability(selectedVariant, container);
        
        // Actualizar URL del navegador si es necesario
        this.updateBrowserURL(selectedVariant, container);
      } else {
        console.warn(`⚠️ Variant ${variantId} not found in product data`);
      }
    } else {
      console.warn('⚠️ No product data found for variant change');
    }
  }

  getProductData(container) {
    // Buscar el script JSON con los datos del producto
    const productScript = container.querySelector('script[type="application/json"][data-product-json], script[id*="Product"][type="application/json"]');
    
    if (productScript) {
      try {
        const productData = JSON.parse(productScript.textContent);
        // console.log('📦 Found product data:', productData);
        return productData;
      } catch (error) {
        console.warn('⚠️ Error parsing product data:', error);
      }
    }
    
    return null;
  }

  updatePrice(variant, container) {
    // console.log(`🏷️ Updating price for variant:`, variant);
    
    // Buscar elementos de precio
    const priceElements = container.querySelectorAll('.price, [data-price], .price-sale, .price-regular');
    
    if (priceElements.length > 0) {
      // Formatear precios
      const price = this.formatMoney(variant.price);
      
      // Actualizar precio principal
      const mainPriceElement = container.querySelector('.price-sale, .price-regular:not(s), .price');
      if (mainPriceElement) {
        mainPriceElement.textContent = price;
      }
      
      // Validación numérica para compare_at_price
      const compareAtPrice = variant.compare_at_price;
      const regularPrice = variant.price;
      
      // Solo mostrar compare_at_price si existe y es numéricamente mayor que el precio regular
      if (compareAtPrice && compareAtPrice !== 0 && compareAtPrice > regularPrice) {
        const formattedComparePrice = this.formatMoney(compareAtPrice);
        const comparePriceElement = container.querySelector('.price-regular s, .price-compare, .price-old');
        if (comparePriceElement) {
          comparePriceElement.textContent = formattedComparePrice;
          comparePriceElement.style.display = '';
        }
        
        // Mostrar elementos de descuento
        const discountElements = container.querySelectorAll('.discount, .on-sale');
        discountElements.forEach(el => el.style.display = 'block');
      } else {
        // Ocultar precio de comparación y elementos de descuento
        const comparePriceElement = container.querySelector('.price-regular s, .price-compare, .price-old');
        if (comparePriceElement) {
          comparePriceElement.style.display = 'none';
        }
        
        const discountElements = container.querySelectorAll('.discount, .on-sale');
        discountElements.forEach(el => el.style.display = 'none');
      }
      
      // console.log('✅ Price updated');
    }
  }

  updateProductImage(variant, container) {
    // console.log(`🖼️ Updating image for variant:`, variant);
    
    if (variant.featured_image || variant.image) {
      const newImageSrc = variant.featured_image?.src || variant.image?.src;
      
      if (newImageSrc) {
        // Actualizar imagen principal
        const mainImage = container.querySelector('.content-img img, .product-image img, .changeImage');
        if (mainImage) {
          mainImage.src = newImageSrc;
          mainImage.srcset = ''; // Limpiar srcset para evitar conflictos
          // console.log('✅ Main image updated');
        }
        
        // Actualizar slider si existe
        const sliderImages = container.querySelectorAll('.content-slider img');
        if (sliderImages.length > 0 && typeof $ !== 'undefined' && $.fn.slick) {
          // Buscar la slide que corresponde a esta imagen
          sliderImages.forEach((img, index) => {
            if (img.src.includes(variant.id) || img.alt.includes(variant.title)) {
              $(container.querySelector('.content-slider')).slick('slickGoTo', index);
            }
          });
        }
      }
    }
  }

  updateAvailability(variant, container) {
    // console.log(`📦 Updating availability for variant:`, variant);
    
    // Determinar si se puede comprar (igual que en la interna)
    const canPurchase = variant && (variant.available || variant.inventory_policy === "continue");
    
    // Buscar botones de agregar al carrito (igual que en la interna)
    const addToCartButtons = container.querySelectorAll('.product-confirm-select:not(.hidden)');
    const addToCartForms = container.querySelectorAll('.add-to-cart-ec-form');
    
    // console.log(`📦 Found ${addToCartButtons.length} add to cart buttons and ${addToCartForms.length} forms`);
    
    // Actualizar botones (igual que en la interna)
    addToCartButtons.forEach(button => {
      if (canPurchase) {
        button.disabled = false;
        button.classList.remove('disabled');
        button.textContent = button.classList.contains('btn-secondary') ? 'Add to cart' : 'add to cart';
        button.type = 'submit';
      } else {
        button.disabled = true;
        button.classList.add('disabled');
        button.textContent = 'Out of stock';
        button.type = 'button';
      }
    });

    // Actualizar formularios (igual que en la interna)
    addToCartForms.forEach(form => {
      const wrapper = form.parentElement;

      // Elimina botón dinámico anterior si existe
      const previousOutBtn = wrapper.querySelector('.dynamic-out-of-stock-button');
      if (previousOutBtn) previousOutBtn.remove();

      if (canPurchase) {
        form.style.display = '';
      } else {
        form.style.display = 'none';

        // Crear solo si no existe ya (igual que en la interna)
        const outOfStockBtn = document.createElement('button');
        outOfStockBtn.type = 'button';
        outOfStockBtn.className = 'product-confirm-select btn disabled dynamic-out-of-stock-button';
        outOfStockBtn.disabled = true;
        outOfStockBtn.textContent = 'Out of stock';
        wrapper.appendChild(outOfStockBtn);
      }
    });
    
    // Actualizar elementos de disponibilidad adicionales
    const availabilityElements = container.querySelectorAll('.availability, .stock-status');
    availabilityElements.forEach(element => {
      if (canPurchase) {
        element.textContent = 'En stock';
        element.classList.remove('sold-out');
        element.classList.add('available');
      } else {
        element.textContent = 'Agotado';
        element.classList.remove('available');
        element.classList.add('sold-out');
      }
    });
    
    // Trigger pickup availability update si existe
    const pickupElement = container.querySelector('[data-pickup-availability]');
    if (pickupElement && window.PickupAvailability) {
      pickupElement.dispatchEvent(new CustomEvent('variant:change', {
        detail: { variant: variant }
      }));
    }
    
    // console.log(`✅ Availability updated: canPurchase=${canPurchase}, variant available=${variant?.available}`);
  }

  updateBrowserURL(variant, container) {
    // Actualizar URL del navegador para reflejar la variante seleccionada
    const productInfo = container.querySelector('product-form');
    if (productInfo && productInfo.dataset.updateUrl === 'true') {
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }

  initPopupHandlers(container) {
    // console.log('🔧 Initializing popup handlers for modal');
    
    // Abrir popups (igual que en main-product.js pero solo dentro del modal)
    const popupTriggers = container.querySelectorAll('.click-to-open-popup');
    popupTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const popupName = trigger.dataset.popup;
        // console.log(`🔧 Opening popup: ${popupName}`);
        
        if (popupName === 'size-guide') {
          this.openSizeGuideInModal(container);
        } else {
          // Para otros tipos de popup, buscar primero en el contenedor del modal
          let popupElement = container.querySelector(`.container-popup-product.${popupName}`);
          
          // Si no está en el modal, buscar en el documento completo (ya cargado por la página completa)
          if (!popupElement) {
            popupElement = document.querySelector(`.container-popup-product.${popupName}`);
          }
          
          if (popupElement) {
            // Asegurar que el popup esté por encima del modal
            popupElement.style.zIndex = '10000';
            popupElement.classList.add('active');
            // console.log(`✅ Popup ${popupName} opened above modal (z-index: 10000)`);
          } else {
            console.warn(`⚠️ Popup element .container-popup-product.${popupName} not found`);
            // console.log('Available popups:', document.querySelectorAll('.container-popup-product').length);
          }
        }
      });
    });
    
    // Inicializar eventos de cierre SOLO una vez globalmente
    if (!this.popupEventsInitialized) {
      this.initGlobalPopupCloseHandlers();
      this.popupEventsInitialized = true;
    }
    
    // console.log(`✅ Initialized ${popupTriggers.length} popup triggers`);
  }

  initGlobalPopupCloseHandlers() {
    // console.log('🔧 Initializing global popup close handlers (one time only)');
    
    // Manejar cierre de popups - SOLO con delegación de eventos global
    document.addEventListener('click', (e) => {
      // Verificar si se hizo click en un botón de cerrar popup
      if (e.target.closest('.close-popup')) {
        e.preventDefault();
        e.stopPropagation();
        
        const closeButton = e.target.closest('.close-popup');
        const popupContainer = closeButton.closest('.container-popup-product');
        
        if (popupContainer) {
          popupContainer.classList.remove('active');
          // console.log('🔴 Popup closed via close button');
          
          // También remover el overlay si existe
          const overlay = popupContainer.querySelector('.popup-overlay');
          if (overlay) {
            overlay.classList.remove('active');
          }
        }
      }
      
      // También cerrar si se hace click en el overlay del popup
      if (e.target.classList.contains('container-popup-product') && e.target.classList.contains('active')) {
        e.target.classList.remove('active');
        // console.log('🔴 Popup closed via overlay click');
      }
    }, true); // useCapture para asegurar que se ejecute antes que otros handlers
    
    // Cerrar popups con ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const activePopups = document.querySelectorAll('.container-popup-product.active');
        activePopups.forEach(popup => {
          popup.classList.remove('active');
          // console.log('🔴 Popup closed via ESC key');
        });
      }
    });
    
    // console.log('✅ Global popup close handlers initialized');
  }

  openSizeGuideInModal(container) {
    // console.log('📏 Opening size guide in modal');
    
    // Buscar si ya existe el size-guide en el DOM
    let sizeGuide = document.querySelector('.container-popup-product.size-guide');
    
    if (!sizeGuide) {
      // console.log('📏 Size guide not found, creating it');
      
      // Buscar el product ID del container
      const productInfo = container.querySelector('product-form');
      const productId = productInfo ? productInfo.dataset.productId : '';
      
      // Obtener las opciones de tamaño del producto actual
      const productData = this.getProductData(container);
      let sizeOptions = [];
      
      if (productData && productData.options) {
        const sizeOption = productData.options.find(option => 
          option.name === 'Size' || option.name === 'Talla' || option.name === 'size'
        );
        
        if (sizeOption && sizeOption.values) {
          sizeOptions = sizeOption.values;
        }
      }
      
      // Si no encontramos opciones del producto, usar valores por defecto
      if (sizeOptions.length === 0) {
        sizeOptions = ['46.5', '50', '53', '56', '59.5'];
      }
      
      // Crear el HTML del size guide dinámicamente
      const sizeGuideHTML = this.createSizeGuideHTML(productId, sizeOptions);
      
      // Insertar en el DOM
      document.body.insertAdjacentHTML('beforeend', sizeGuideHTML);
      sizeGuide = document.querySelector('.container-popup-product.size-guide');
      
      // Inicializar la funcionalidad del size guide
      if (sizeGuide) {
        this.initializeSizeGuide(sizeGuide);
      }
    }
    
    // Mostrar el size guide
    if (sizeGuide) {
      sizeGuide.style.zIndex = '10000'; // Asegurar que esté por encima del modal
      sizeGuide.classList.add('active');
      // console.log('✅ Size guide opened above modal (z-index: 10000)');
    } else {
      console.error('❌ Failed to create or find size guide');
    }
  }

  createSizeGuideHTML(productId, sizeOptions) {
    // console.log('📏 Creating size guide HTML for sizes:', sizeOptions);
    
    // Generar filas de la tabla con las tallas disponibles
    const sizeRows = sizeOptions.map(size => `
      <tr data-size="${size}">
        <td class="size-name">${size}</td>
        <td class="rider-height" data-cm="" data-in="">-</td>
        <td class="inseam" data-cm="" data-in="">-</td>
      </tr>
    `).join('');
    
    return `
      <div class="container-popup-product size-guide" data-product-id="${productId}">
        <div class="container">
          <div class="popup-header">
            <div class="content-title">
              <p>Size guide</p>
            </div>
            <div class="close-popup">
              <iconify-icon icon="ei:close"></iconify-icon>
            </div>
          </div>
          <div class="popup-body">
            <div class="content-units">
              <div class="unit active" data-unit="cm">
                <p>cm</p>
              </div>
              <div class="unit" data-unit="in">
                <p>in</p>
              </div>
            </div>
            <div class="content-table">
              <table id="size-table">
                <thead>
                  <tr>
                    <th>Size</th>
                    <th>Rider Height</th>
                    <th>Inseam</th>
                  </tr>
                </thead>
                <tbody>
                  ${sizeRows}
                </tbody>
              </table>
            </div>
            <div class="content-what-my-size">
              <div class="size-title">
                <h3>What is my size?</h3>
                <p>Enter your height and we'll calculate your size.</p>
              </div>
              <div class="size-form">
                <form id="size-calculator-form">
                  <div class="row">
                    <div class="col number">
                      <input type="number" id="height-input" placeholder="Your height" min="120" max="220">
                      <p class="unit-number" data-unit-display="cm">cm</p>
                    </div>
                    <div class="col submit">
                      <input type="submit" value="Calculate" class="btn secondary">
                    </div>
                  </div>
                </form>
              </div>
              <div class="size-form-result" id="calculation-result" style="display: none;">
                <div class="item">
                  <div class="item-text">
                    <p>Height</p>
                  </div>
                  <div class="item-number">
                    <p id="height-display">-- <span class="unit-span">cm</span></p>
                  </div>
                </div>
                <div class="item">
                  <div class="item-text">
                    <p>Recommended size</p>
                  </div>
                  <div class="item-number">
                    <p id="size-recommendation">--</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  initializeSizeGuide(sizeGuide) {
    // console.log('📏 Initializing size guide functionality');
    
    // Get available sizes from the product (numeric sizes)
    const availableSizes = [];
    
    // Collect available sizes from table rows
    const sizeRows = sizeGuide.querySelectorAll('[data-size]');
    sizeRows.forEach(row => {
      const sizeName = row.dataset.size;
      if (sizeName) {
        // Convert to number for proper sorting
        const numericSize = parseFloat(sizeName);
        if (!isNaN(numericSize)) {
          availableSizes.push({ 
            name: sizeName, 
            numeric: numericSize 
          });
        }
      }
    });
    
    // Sort sizes numerically
    availableSizes.sort((a, b) => a.numeric - b.numeric);
    
    // Size mapping based on typical bike frame sizing
    const getSizeRecommendation = (frameSize) => {
      const numSize = parseFloat(frameSize);
      
      // Approximate height and inseam ranges for different frame sizes
      if (numSize <= 44) return { 
        heightRange: [150, 165], 
        heightRangeIn: [59, 65],
        inseamRange: [72, 78],
        inseamRangeIn: [28, 31]
      };
      if (numSize <= 47) return { 
        heightRange: [160, 170], 
        heightRangeIn: [63, 67],
        inseamRange: [76, 82],
        inseamRangeIn: [30, 32]
      };
      if (numSize <= 50) return { 
        heightRange: [165, 175], 
        heightRangeIn: [65, 69],
        inseamRange: [79, 85],
        inseamRangeIn: [31, 33]
      };
      if (numSize <= 52) return { 
        heightRange: [170, 180], 
        heightRangeIn: [67, 71],
        inseamRange: [82, 88],
        inseamRangeIn: [32, 35]
      };
      if (numSize <= 54) return { 
        heightRange: [175, 185], 
        heightRangeIn: [69, 73],
        inseamRange: [85, 91],
        inseamRangeIn: [33, 36]
      };
      if (numSize <= 56) return { 
        heightRange: [180, 190], 
        heightRangeIn: [71, 75],
        inseamRange: [88, 94],
        inseamRangeIn: [35, 37]
      };
      if (numSize <= 58) return { 
        heightRange: [185, 195], 
        heightRangeIn: [73, 77],
        inseamRange: [91, 97],
        inseamRangeIn: [36, 38]
      };
      if (numSize <= 60) return { 
        heightRange: [190, 200], 
        heightRangeIn: [75, 79],
        inseamRange: [94, 100],
        inseamRangeIn: [37, 39]
      };
      return { 
        heightRange: [195, 210], 
        heightRangeIn: [77, 83],
        inseamRange: [97, 105],
        inseamRangeIn: [38, 41]
      };
    };
    
    // Current unit (cm or in)
    let currentUnit = 'cm';
    
    // Initialize size data in table
    function initializeSizeTable() {
      availableSizes.forEach(sizeObj => {
        const sizeName = sizeObj.name;
        const row = sizeGuide.querySelector(`[data-size="${sizeName}"]`);
        if (row) {
          const recommendation = getSizeRecommendation(sizeName);
          const riderHeightCell = row.querySelector('.rider-height');
          const inseamCell = row.querySelector('.inseam');
          
          // Set height range data
          if (riderHeightCell) {
            riderHeightCell.dataset.cm = `${recommendation.heightRange[0]}-${recommendation.heightRange[1]}`;
            riderHeightCell.dataset.in = `${recommendation.heightRangeIn[0]}-${recommendation.heightRangeIn[1]}`;
          }
          
          // Set inseam range data
          if (inseamCell) {
            inseamCell.dataset.cm = `${recommendation.inseamRange[0]}-${recommendation.inseamRange[1]}`;
            inseamCell.dataset.in = `${recommendation.inseamRangeIn[0]}-${recommendation.inseamRangeIn[1]}`;
          }
        }
      });
      
      updateTableUnits();
    }
    
    // Update table based on current unit
    function updateTableUnits() {
      const riderHeightCells = sizeGuide.querySelectorAll('.rider-height');
      const inseamCells = sizeGuide.querySelectorAll('.inseam');
      
      riderHeightCells.forEach(cell => {
        const value = cell.dataset[currentUnit];
        if (value && value !== '') {
          cell.textContent = `${value} ${currentUnit}`;
        } else {
          cell.textContent = '-';
        }
      });
      
      inseamCells.forEach(cell => {
        const value = cell.dataset[currentUnit];
        if (value && value !== '') {
          cell.textContent = `${value} ${currentUnit}`;
        } else {
          cell.textContent = '-';
        }
      });
    }
    
    // Convert cm to inches
    function cmToInches(cm) {
      return Math.round(cm / 2.54);
    }
    
    // Convert inches to cm
    function inchesToCm(inches) {
      return Math.round(inches * 2.54);
    }
    
    // Calculate recommended size based on height
    function calculateSize(height) {
      let heightInCm = currentUnit === 'in' ? inchesToCm(height) : height;
      
      let bestSize = null;
      let bestScore = Infinity;
      
      availableSizes.forEach(sizeObj => {
        const sizeName = sizeObj.name;
        const recommendation = getSizeRecommendation(sizeName);
        const range = recommendation.heightRange;
        
        let score;
        if (heightInCm >= range[0] && heightInCm <= range[1]) {
          score = 0;
        } else {
          if (heightInCm < range[0]) {
            score = range[0] - heightInCm;
          } else {
            score = heightInCm - range[1];
          }
        }
        
        if (score < bestScore) {
          bestScore = score;
          bestSize = sizeName;
        }
      });
      
      return bestSize || (availableSizes.length > 0 ? availableSizes[0].name : null);
    }
    
    // Unit switcher
    const unitButtons = sizeGuide.querySelectorAll('.unit');
    unitButtons.forEach(button => {
      button.addEventListener('click', () => {
        if (button.classList.contains('active')) return;
        
        // Update active state
        unitButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
        
        // Update current unit
        currentUnit = button.dataset.unit;
        
        // Update form labels
        const unitDisplay = sizeGuide.querySelector('[data-unit-display]');
        const unitSpan = sizeGuide.querySelector('.unit-span');
        
        if (unitDisplay) unitDisplay.textContent = currentUnit;
        if (unitSpan) unitSpan.textContent = currentUnit;
        
        // Update table
        updateTableUnits();
        
        // Update height input placeholder and constraints
        const heightInput = sizeGuide.querySelector('#height-input');
        if (heightInput) {
          if (currentUnit === 'cm') {
            heightInput.placeholder = 'Your height';
            heightInput.min = '120';
            heightInput.max = '220';
          } else {
            heightInput.placeholder = 'Your height';
            heightInput.min = '47';
            heightInput.max = '87';
          }
          
          // Clear current value when switching units
          heightInput.value = '';
        }
        
        // Hide result when switching units
        const result = sizeGuide.querySelector('#calculation-result');
        if (result) result.style.display = 'none';
      });
    });
    
    // Size calculator form
    const calculatorForm = sizeGuide.querySelector('#size-calculator-form');
    const heightInput = sizeGuide.querySelector('#height-input');
    const result = sizeGuide.querySelector('#calculation-result');
    const heightDisplay = sizeGuide.querySelector('#height-display');
    const sizeRecommendation = sizeGuide.querySelector('#size-recommendation');
    
    if (calculatorForm) {
      calculatorForm.addEventListener('submit', (e) => {
        e.preventDefault();
        
        const height = parseFloat(heightInput.value);
        
        if (!height || height <= 0) {
          alert('Please enter a valid height');
          return;
        }
        
        // Validate height ranges
        if (currentUnit === 'cm' && (height < 120 || height > 220)) {
          alert('Please enter a height between 120 and 220 cm');
          return;
        }
        
        if (currentUnit === 'in' && (height < 47 || height > 87)) {
          alert('Please enter a height between 47 and 87 inches');
          return;
        }
        
        // Calculate recommended size
        const recommendedSize = calculateSize(height);
        
        // Update display
        heightDisplay.textContent = `${height}`;
        sizeRecommendation.textContent = recommendedSize;
        
        // Show result
        result.style.display = 'block';
        
        // Highlight recommended size in table
        const allRows = sizeGuide.querySelectorAll('[data-size]');
        allRows.forEach(row => row.classList.remove('recommended'));
        
        const recommendedRow = sizeGuide.querySelector(`[data-size="${recommendedSize}"]`);
        if (recommendedRow) {
          recommendedRow.classList.add('recommended');
        }
      });
    }
    
    // Initialize table
    initializeSizeTable();
    
    // console.log('✅ Size guide functionality initialized');
  }

  formatMoney(cents) {
    // Formatear precio según la configuración de Shopify
    // Esta es una implementación básica, idealmente usarías Shopify.formatMoney
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    } else {
      // Fallback básico
      const dollars = (cents / 100).toFixed(2);
      return `$${dollars}`;
    }
  }

  // NO NECESITAMOS handleAddToCart aquí - minicart.js se encarga de todo
  // Solo cerramos el modal cuando detectamos submit

  initShopifyElements(container) {
    // console.log('🔧 Initializing Shopify custom elements');
    
    // Lista de custom elements de Shopify que necesitamos inicializar
    const customElementTypes = [
      'product-form',
      'product-form', 
      'variant-radios',
      'variant-selects',
      'pickup-availability'
    ];
    
    customElementTypes.forEach(elementType => {
      const elements = container.querySelectorAll(elementType);
      
      elements.forEach((element, index) => {
        // console.log(`🔧 Initializing ${elementType} element ${index + 1}`);
        
        // Marcar como inicializado en modal
        element.setAttribute('data-modal-init', 'true');
        
        // Forzar reconexión si el método existe
        if (element.connectedCallback && typeof element.connectedCallback === 'function') {
          try {
            element.connectedCallback();
            // console.log(`✅ ${elementType} connected successfully`);
          } catch (error) {
            console.warn(`⚠️ Error connecting ${elementType}:`, error);
          }
        }
        
        // Trigger eventos específicos para cada tipo
        const eventName = `${elementType}:loaded`;
        element.dispatchEvent(new CustomEvent(eventName, { bubbles: true }));
        
        // Para product-info, también trigger el evento de sección cargada
        if (elementType === 'product-form') {
          element.dispatchEvent(new CustomEvent('shopify:section:load', { 
            bubbles: true,
            detail: { sectionId: element.dataset.section }
          }));
        }
      });
    });
    
    // También inicializar elementos con clases específicas que puedan tener JavaScript
    const productElements = container.querySelectorAll('[class*="product"], [data-product-id]');
    productElements.forEach(element => {
      if (element.dataset.productId) {
        element.dispatchEvent(new CustomEvent('product:initialized', { 
          bubbles: true,
          detail: { productId: element.dataset.productId }
        }));
      }
    });
    
    // console.log('✅ All Shopify elements initialized');
  }

  initSliders(container, initialVariantId = null) {
    // console.log('🔧 Initializing sliders');
    
    if (typeof $ === 'undefined' || !$.fn.slick) {
      console.warn('⚠️ jQuery or Slick not available');
      return;
    }

    const contentSlider = container.querySelector('.content-slider');
    const contentNavSlider = container.querySelector('.content-nav-slider');
    const skeleton = container.querySelector('.content-slider-skeleton');
    
    if (!contentSlider) {
      console.warn('⚠️ Content slider not found');
      return;
    }

    // console.log('📱 Found content slider, initializing...');
    
    // Limpiar cualquier inicialización previa
    if (contentSlider.classList.contains('slick-initialized')) {
      // console.log('🔄 Destroying existing slick');
      $(contentSlider).slick('unslick');
    }
    if (contentNavSlider && contentNavSlider.classList.contains('slick-initialized')) {
      $(contentNavSlider).slick('unslick');
    }

    // IMPORTANTE: Asegurar que el slider esté visible desde el inicio
    contentSlider.style.visibility = 'visible';
    contentSlider.style.display = 'block';
    contentSlider.classList.remove('hide');

    // Ocultar skeleton si existe
    if (skeleton) {
      skeleton.style.display = 'none';
      skeleton.classList.remove('show');
    }

    try {
      // Inicializar slider principal
      $(contentSlider).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        infinite: false,
        fade: true,
        asNavFor: contentNavSlider ? '.quick-add-modal .content-nav-slider' : null
      });

      // Mantener comportamiento original de las imágenes - NO modificar eventos
      // console.log('✅ Content slider initialized successfully');

      // Inicializar slider de navegación si existe
      if (contentNavSlider) {
        $(contentNavSlider).slick({
          slidesToShow: 1,
          asNavFor: '.quick-add-modal .content-slider',
          dots: false,
          arrows: false,
          infinite: false,
          variableWidth: true,
          focusOnSelect: true
        });
        // console.log('✅ Nav slider initialized');
      }

      // Log para debugging
      const images = contentSlider.querySelectorAll('img');
      // console.log(`🔍 Found ${images.length} images in initialized slider`);
      images.forEach((img, index) => {
        // console.log(`🖼️ Image ${index + 1}: src=${img.src}, visible=${img.offsetWidth > 0 && img.offsetHeight > 0}`);
      });

    } catch (error) {
      console.error('❌ Error initializing sliders:', error);
      
      // Fallback: asegurar que el contenido sea visible
      contentSlider.style.visibility = 'visible';
      contentSlider.style.display = 'block';
      if (skeleton) {
        skeleton.style.display = 'none';
      }
    }
  }

  executeProductScripts(container) {
    // console.log('🔧 Executing product scripts');
    
    // Buscar y ejecutar scripts JSON primero (datos del producto)
    const jsonScripts = container.querySelectorAll('script[type="application/json"]');
    jsonScripts.forEach(script => {
      if (script.id && script.id.includes('Product')) {
        // console.log(`✅ Found product data script: ${script.id}`);
        // Estos scripts ya están en el DOM, no necesitan ejecución
      }
    });
    
    // Ejecutar scripts inline que contienen lógica
    const inlineScripts = container.querySelectorAll('script:not([type="application/json"]):not([src])');
    
    inlineScripts.forEach((script, index) => {
      if (script.textContent && script.textContent.trim()) {
        try {
          // console.log(`🔧 Executing inline script ${index + 1}`);
          
          // Crear un contexto seguro para el modal
          const safeScript = `
            (function() {
              // Scope del modal
              const modalContainer = arguments[0];
              const quickAddModal = arguments[1];
              
              // Override de funciones globales para que trabajen en el modal
              const originalDocumentQuery = document.querySelector.bind(document);
              const originalDocumentQueryAll = document.querySelectorAll.bind(document);
              
              // Temporal override para que busque en el modal primero
              document.querySelector = function(selector) {
                const modalResult = modalContainer.querySelector(selector);
                if (modalResult) return modalResult;
                return originalDocumentQuery(selector);
              };
              
              document.querySelectorAll = function(selector) {
                const modalResults = modalContainer.querySelectorAll(selector);
                if (modalResults.length > 0) return modalResults;
                return originalDocumentQueryAll(selector);
              };
              
              try {
                // Ejecutar el script original
                ${script.textContent}
              } catch (scriptError) {
                console.warn('Error in product script:', scriptError);
              } finally {
                // Restaurar funciones originales
                document.querySelector = originalDocumentQuery;
                document.querySelectorAll = originalDocumentQueryAll;
              }
            })
          `;
          
          const executeInModalContext = new Function('container', 'modal', safeScript);
          executeInModalContext(container, this);
          
          // console.log(`✅ Script ${index + 1} executed successfully`);
          
        } catch (error) {
          console.warn(`⚠️ Error executing script ${index + 1}:`, error);
        }
      }
    });
  }

  triggerEvents(container) {
    // console.log('🔧 Triggering initialization events');
    
    // 1. Trigger eventos de Shopify
    const productInfo = container.querySelector('product-form');
    if (productInfo) {
      productInfo.dispatchEvent(new CustomEvent('product-form:loaded', { bubbles: true }));
      productInfo.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
    }
    
    // 2. Trigger eventos de cambio de variante para inicializar estado correcto
    const variantSelect = container.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.value) {
      // console.log(`🔧 Triggering variant change for: ${variantSelect.value}`);
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
    
    // 3. Trigger eventos de radio buttons si existen
    const selectedVariantRadio = container.querySelector('input[name="id"]:checked');
    if (selectedVariantRadio) {
      // console.log(`🔧 Triggering variant radio change for: ${selectedVariantRadio.value}`);
      selectedVariantRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    
    // 4. Trigger eventos globales
    window.dispatchEvent(new Event('resize'));
    document.dispatchEvent(new Event('DOMContentLoaded'));
    
    // 5. Trigger evento custom para notificar que el modal está listo
    setTimeout(() => {
      container.dispatchEvent(new CustomEvent('quickadd:ready', { 
        bubbles: true,
        detail: { container: container }
      }));
      // console.log('✅ All initialization events triggered - Modal ready!');
      this.showAddToCartButtons();
    }, 100);
  }

  // NOTA: métodos open() y close() duplicados eliminados.
  // Los correctos con focus management están arriba (open ~línea 497, close ~591)

  showLoading() {
    const loading = this.modal?.querySelector('.quick-add-loading');
    const content = this.modal?.querySelector('.quick-add-product-content');
    
    if (loading) loading.style.display = 'flex';
    if (content) content.style.display = 'none';
  }

  hideLoading() {
    const loading = this.modal?.querySelector('.quick-add-loading');
    const content = this.modal?.querySelector('.quick-add-product-content');
    
    if (loading) loading.style.display = 'none';
    if (content) content.style.display = 'block';
  }

  showError(message) {
    // console.log(`🔴 Showing error: ${message}`);
    this.hideLoading();
    
    // NUEVO: Restaurar el main product en caso de error
    this.restoreMainProduct();
    
    if (this.modalContent) {
      this.modalContent.innerHTML = `
        <div style="padding: 40px; text-align: center;">
          <p style="color: #e74c3c; font-size: 16px; margin-bottom: 20px;">${message}</p>
          <button onclick="event.stopPropagation(); window.quickAddModal.close()" style="padding: 10px 20px; background: #333; color: white; border: none; border-radius: 4px; cursor: pointer;">
            Cerrar
          </button>
        </div>
      `;
      this.modalContent.style.display = 'block';
    }
  }

  clearContent() {
    if (!this.modalContent) return;
    
    // Limpiar sliders
    const sliders = this.modalContent.querySelectorAll('.slick-initialized');
    sliders.forEach(slider => {
      if (typeof $ !== 'undefined' && $.fn.slick) {
        $(slider).slick('destroy');
      }
    });
    
    this.modalContent.innerHTML = '';
  }
}

// Inicializar globalmente - versión robusta
function initQuickAddModal() {
  // console.log('🚀 Initializing QuickAddModal');
  
  if (window.quickAddModal) {
    // console.log('⚠️ QuickAddModal already exists, replacing...');
  }
  
  try {
    window.quickAddModal = new QuickAddModal();
    // console.log('✅ QuickAddModal ready');
  } catch (error) {
    console.error('❌ Error initializing QuickAddModal:', error);
  }
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuickAddModal);
} else {
  // DOM ya está listo
  initQuickAddModal();
}

// También inicializar en load como fallback
window.addEventListener('load', function() {
  if (!window.quickAddModal) {
    // console.log('🔄 Fallback initialization');
    initQuickAddModal();
  }
});

// Para debugging - exponer en consola
window.QuickAddModal = QuickAddModal;